/** Shared timing for the sidebar slide, so the panel and the collapsed rail move together. */

export const SIDEBAR_SLIDE_MS = 200;

export const SIDEBAR_SLIDE =
  'duration-200 ease-[cubic-bezier(0.32,0.72,0,1)] motion-reduce:transition-none';
